@if (schedule(); as schedule) {
    <button
        (click)="handleClick()"
        class="p-4 flex bg-white border-gray-100 gap-3 items-center rounded-xl border select-none w-full"
    >
        <div class="flex gap-2 items-center">
            @if (schedule.log) {
                <app-badge color="gray" variant="light">작성 완료</app-badge>
            } @else {
                <app-badge color="orange" variant="light">작성 대기</app-badge>
            }
            <p class="text-gray-800">
                {{ schedule.startAt | date: "y.MM.dd (E)" }}
            </p>
            <div class="px-1.5 py-0.5 category-badge text-gray-800 text-xs">
                {{ schedule.currentMonthScheduleIndex + 1 }}/{{
                    schedule.currentMonthScheduleCount
                }}
            </div>
        </div>
    </button>
}
